<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="login">
                            <ion-card-header>
                                <ion-card-title>{{ $t('screens.not-found.title') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-item lines="none">
                                    <ion-img :src="require('@/assets/not-found.png')"></ion-img>
                                </ion-item>
                                <ion-item lines="none">
                                    {{ $t('screens.not-found.message') }}
                                </ion-item>
                                <ion-button size="default" expand="block" @click="goBack" type="submit">{{ $t('screens.not-found.back') }}</ion-button>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    export default {
        name: 'NotFound',
        methods: {
            goBack: function() {
                history.go(-1);
            }
        }
    }
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg6.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 1em;
    }

    ion-img {
        width: 100%;
    }

    ion-item {
        --background: none;
        width: 98%;
        margin-left: 1%;
        margin-bottom: .5em;
        text-align: center;
        color: #666;
        font-family: 'Nunito', sans-serif !important;
    }

    ion-button {
        margin-top: 1em;
    }

    ion-card-header {
        --background: none;
    }

    ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    ion-card-title {
        --color: #f05;
        font-size: 2.5em;
        font-weight: bold;
    }

    ion-col {
        padding: 0;
    }
</style>